module.exports = __webpack_public_path__ + "e46613c6fa71355873142612be9158d8.jpg";